import { Tab } from "@renderbus/ui";
import styled from "styled-components";
import ActiveTabLeft from "@/assets/images/active-tab-left.png";
import ActiveTabRight from "@/assets/images/active-tab-right.png";
import ActiveTabMiddle from "@/assets/images/active-tab-middle.png";

export const TopUpTabs = styled(Tab)<{ isForeign?: boolean }>`
  > div:first-child {
    .ant-tabs-nav-wrap {
      border-bottom: 1px solid #3a4449;
    }
    .ant-tabs-nav-operations {
      display: none;
    }
    .ant-tabs-nav-list {
      width: 1012px;
      background: #181a1c;
      .ant-tabs-tab {
        width: 506px !important;
        padding: 0;
        justify-content: center;
        background: #181a1c;
        &.ant-tabs-tab-active {
          height: 50px;
          padding: 0;
          background-image: url(${ActiveTabLeft});
          background-size: 100% 100%;
        }
      }
      .ant-tabs-tab + .ant-tabs-tab {
        margin-left: 0;
        &.ant-tabs-tab-active {
          height: 50px;
          background-image: url(${ActiveTabRight}) !important;
          background-size: 100% 100%;
        }
      }
    }
  }

  &.ant-tabs.ant-tabs-top {
    .ant-tabs-nav {
      height: 50px;
      .ant-tabs-ink-bar[style] {
        &::after {
          display: none;
        }
      }
      .ant-tabs-tab-btn {
        font-size: 18px;
        color: #b2b8bb;
      }
      .ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #ffffff;
      }
    }
  }
`;

export const TopUpTowOrThreeTabs = styled(Tab)<{ isForeign?: boolean }>`
  > .ant-tabs-nav .ant-tabs-nav-wrap {
    .ant-tabs-nav-wrap {
      border-bottom: 1px solid #3a4449;
    }
    .ant-tabs-nav-operations {
      display: none;
    }
    .ant-tabs-nav-list {
      width: 1012px;
      background: #181a1c;
    }
  }
  &.ant-tabs.ant-tabs-top {
    .ant-tabs-nav {
      height: 50px;
      .ant-tabs-ink-bar[style] {
        &::after {
          display: none;
        }
      }
      .ant-tabs-tab-btn {
        font-size: 18px;
        color: #b2b8bb;
      }
      .ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #ffffff;
      }
    }
  }
  > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list {
    .ant-tabs-tab {
      padding: 0;
      justify-content: center;
      background: #181a1c;
      margin-left: 0;
      &.ant-tabs-tab-active {
        height: 50px;
        padding: 0;
        background-size: 100% 100%;
      }
    }
  }
  &.length-1,
  &.length-2 {
    > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list {
      .ant-tabs-tab {
        width: 506px;
        &:nth-child(1).ant-tabs-tab-active {
          background-image: url(${ActiveTabLeft});
        }
        &:nth-child(2).ant-tabs-tab-active {
          background-image: url(${ActiveTabRight});
        }
      }
    }
  }
  &.length-3 {
    > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list {
      .ant-tabs-tab {
        width: 337px;
        &:nth-child(1).ant-tabs-tab-active {
          background-image: url(${ActiveTabLeft});
        }
        &:nth-child(2).ant-tabs-tab-active {
          background-image: url(${ActiveTabMiddle});
        }
        &:nth-child(3).ant-tabs-tab-active {
          background-image: url(${ActiveTabRight});
        }
      }
    }
  }
`;
